import { toggleCharm, HeaderCharmType } from 'owa-header-store';
import { action } from 'satcheljs/lib/legacy';
import { logUsage } from 'owa-analytics';

export default action('launchHelpPane')(function launchHelpPane() {
    logUsage('HelpDeepLinkRoute');
    toggleCharm(HeaderCharmType.HelpCharm);
});
